import { NetworkType } from '@layerswap/widget-types';
import sha3 from "js-sha3";
import KnownInternalNames from "../../knownIds";
import { AddressSelectionMode } from "../../types";
export const name = 'EVM';
const { keccak256 } = sha3;
function isChecksumAddress(address) {
    // Check each case
    address = address.replace('0x', '');
    const addressHash = keccak256(address.toLowerCase());
    for (let i = 0; i < 40; i++) {
        // the nth letter should be uppercase if the nth digit of casemap is 1
        if ((parseInt(addressHash[i], 16) > 7 && address[i].toUpperCase() !== address[i]) || (parseInt(addressHash[i], 16) <= 7 && address[i].toLowerCase() !== address[i])) {
            return false;
        }
    }
    return true;
}
function isValidEtherAddress(address) {
    if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
        // check if it has the basic requirements of an address
        return false;
    }
    else if (/^(0x)?[0-9a-f]{40}$/.test(address) || /^(0x)?[0-9A-F]{40}$/.test(address)) {
        // If it's all small caps or all all caps, return true
        return true;
    }
    else {
        // Otherwise check each case
        return isChecksumAddress(address);
    }
}
export class EVMAddressUtilsProvider {
    constructor() {
        this.providerName = name;
        this.networkType = NetworkType.EVM;
        this.label = 'EVM';
        this.selection = AddressSelectionMode.Networks;
        this.defaultScope = 'all';
    }
    supportsNetwork(network) {
        return (network.type === NetworkType.EVM && !!network.token)
            || KnownInternalNames.Networks.HyperliquidMainnet.includes(network.name)
            || KnownInternalNames.Networks.HyperliquidTestnet.includes(network.name)
            || KnownInternalNames.Networks.PolymarketMainnet.includes(network.name);
    }
    isValidAddress(props) {
        const { address } = props;
        if (!address) {
            return false;
        }
        return isValidEtherAddress(address);
    }
    addressFormat(props) {
        const { address } = props;
        return address.toLowerCase();
    }
}
